import { render, staticRenderFns } from "./QuickScore.vue?vue&type=template&id=17468036&"
import script from "./QuickScore.vue?vue&type=script&lang=js&"
export * from "./QuickScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports